import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './brands.css'

const BRANDS = [
  require('images/brands/udder-belly.png'),
  require('images/brands/ghd.png'),
  require('images/brands/tanqueray.png'),
  require('images/brands/diageo.png'),
  require('images/brands/cirque-du-soleil.png'),
  require('images/brands/guinness.png'),
  require('images/brands/captain-morgan.png'),
  require('images/brands/smirnoff.png'),
  require('images/brands/ben-jerry.png'),
]

const Brands = ({ staticUrl }) => (
  <div styleName="brands">
    <div styleName="brands-content">
      <h1 styleName="title">You will be in a great company</h1>
      <p styleName="text">
        We’ve worked to deliver an unparalleled event experience for a long list of big name brands.
      </p>

      <ul styleName="list">
        {BRANDS.map((url, i) => (
          <li key={i} styleName="list__item">
            <img alt={url} src={`${staticUrl}/${url}`} styleName="list__img" />
          </li>
        ))}
      </ul>
    </div>
  </div>
)

Brands.propTypes = {
  staticUrl: PropTypes.string,
}

export default CSSModules(Brands, styles)



/** WEBPACK FOOTER **
 ** ./src/containers/ticketing-page/brands/brands.js
 **/